<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="map">
<p class="ct"><a class="xref" href="#/pppcondispos005#toc">Posadas County Map</a></p>
<p class="fig"><img alt="" src="ppp-posadas-map.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppcondispos007.vue?297b0b36